import { useAuth, PermissionAction } from '../contexts/AuthContext';

/**
 * Hook para verificar permisos de manera conveniente
 * SISTEMA DE PERMISOS DESHABILITADO - Todos los usuarios tienen acceso completo
 */
export function usePermissions() {
  const { isAdmin } = useAuth();

  /**
   * Verifica si el usuario tiene permiso de visualización en una sección
   * SISTEMA DE PERMISOS DESHABILITADO - Siempre retorna true
   */
  const canView = (section: string): boolean => {
    return true;
  };

  /**
   * Verifica si el usuario tiene permiso de edición en una sección
   * SISTEMA DE PERMISOS DESHABILITADO - Siempre retorna true
   */
  const canEdit = (section: string): boolean => {
    return true;
  };

  /**
   * Verifica si el usuario tiene un permiso específico
   * SISTEMA DE PERMISOS DESHABILITADO - Siempre retorna true
   */
  const can = (section: string, action: PermissionAction): boolean => {
    return true;
  };

  return {
    canView,
    canEdit,
    can,
    isAdmin,
  };
}

